import type { NavigateFunction } from "react-router-dom";

/**
 * Defer client navigation so ApexCharts can finish DOM updates (avoids
 * "Cannot read properties of null (reading 'getAttribute')" during chart teardown).
 */
export function deferredNavigate(navigate: NavigateFunction, to: string): void {
  window.setTimeout(() => {
    navigate(to);
  }, 0);
}
